// Pure "may this message be sent?" logic for MessageDialog. The dialog only
// renders what this returns. Every blocker except HARD_BLOCKERS can be knowingly overridden with the
// single "continue anyway" box — a gate that cannot be passed deliberately would
// deadlock the owner on a field that can never be filled.

export function sendBlockers({ hasAudit, readiness, consent, identityMissing, signature, needsKit }) {
  const out = [];
  if (hasAudit && readiness && !readiness.ready) out.push("not_ready");
  if (!consent || consent === "none") out.push("no_consent");
  if (identityMissing?.length) out.push("no_identity");
  if (!(signature || "").trim()) out.push("no_signature");
  if (needsKit) out.push("no_kit");
  return out;
}

// Never liftable by the "continue anyway" box.
export const HARD_BLOCKERS = ["no_signature", "no_kit"];

export const BLOCKER_TEXT = {
  not_ready: "Rapor henüz gönderilebilir değil — ölçümler eksik.",
  no_consent:
    "Bu firma için onay kaydı yok. Almanya'da önceden onay olmadan ticari WhatsApp/e-posta göndermek UWG §7 kapsamında risklidir. Önce telefonla arayıp sözlü onay al ve aşağıdan “sözlü” seç.",
  no_identity:
    "Rapor sayfasında gönderen bilgisi görünmüyor (REACT_APP_SENDER_NAME / _PHONE / _EMAIL eksik). İmzasız bir rapora 39 € ödenmez.",
  no_signature: "Mesajın imzası için “Adınız / Firma” alanı boş.",
  no_kit: "Almanca mesaj için önce 'Dijital Tarama' çalıştırıp rapor linkini oluştur.",
};

export const READINESS_FIELD_LABELS = {
  digital_score: "Dijital puan",
  score_pillars: "Puan sütunları",
  score_checks: "Kontrol sayıları",
  audit_findings: "Bulgular",
  report_token: "Rapor linki",
  maps_rank: "Google Maps sırası",
  grid_rank: "Isı haritası",
  citations: "Dizin kayıtları",
  review_analysis: "Yorum analizi",
  benchmark: "Bölge karşılaştırması — oturumda “Dijital Tarama” çalıştır",
  top3: "Rakip karşılaştırması — oturumda “Dijital Tarama” çalıştır",
};
